import { render, staticRenderFns } from "./OrderInfoSection.vue?vue&type=template&id=58933367&scoped=true&"
import script from "./OrderInfoSection.vue?vue&type=script&lang=js&"
export * from "./OrderInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoSection.vue?vue&type=style&index=0&id=58933367&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58933367",
  null
  
)

export default component.exports